const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
      console.log(element)
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
    target.closest('.toggle_form').querySelector('.edit_address').classList.toggle('hidden')
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
    
      
    console.log(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`))
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}

(function () {
  const formToggleButton = document.querySelector('.open_contacts')
  // const ordersToggle = document.querySelector('.customer__orders_toggle')
  // if (ordersToggle) {
  //   document.querySelector('.customer__orders_toggle').addEventListener('click', function() {
  //     var element = document.querySelector('.order-history_wr');
  //     if (element.style.maxHeight) {
  //         element.style.maxHeight = null;
  //         element.style.opacity = 0;
  //         this.textContent = 'Open';
  //     } else {
  //         element.style.maxHeight = element.scrollHeight + 'px';
  //         element.style.opacity = 1;
  //         this.textContent = 'Close';
  //     }
  //   });
  // }

  if (formToggleButton) {
    
    const toggleForm = (btn) => {
      var element = document.querySelector('.customer__contacts');
      if (element.style.maxHeight) {
          element.style.maxHeight = null;
          element.style.opacity = 0;
          btn.classList.remove('active')
      } else {
          element.style.maxHeight = element.scrollHeight + 'px';
          element.style.opacity = 1;
          btn.classList.add('active')
      }
    }
    formToggleButton.addEventListener('click', function() {
      toggleForm(formToggleButton)
    });
    if (window.location.href.includes('contact_posted=true')) {
      formToggleButton.classList.add('active')
      toggleForm(formToggleButton)

      let url = window.location.href; 
      const substring = '?contact_posted=true#ContactForm'; 
      const newUrl = url.replace(substring, ''); 

      history.replaceState(null, '', newUrl);
    }
  }
})();
  
